<template>
  <!-- 字典，列表结构 -->
  <list-page :show-shadow="false">
    <search-condition @search="resetSearch" :show-search="true" :show-shadow="false">
      <el-input v-model="searchInfo.searchKey" :placeholder="`请输入${prefix}名称/编码`" @keydown.enter.native="queryList" clearable>
        <template #prefix>搜索</template>
      </el-input>
      <template #option>
        <page-button el-type="primary" @click="resetSearch">查询</page-button>
        <page-button el-type="success" hasPerm="sys:dict:add" :disabled="!editAble" @click="toEditData({})">新建</page-button>
      </template>
    </search-condition>
    <table-list :show-shadow="false" :show-border="false">
      <yq-table border :data="dataList">
        <yq-table-column :label="`${prefix}名称`" prop="dictName"/>
        <yq-table-column :label="`${prefix}编码`" prop="userCode"/>
        <yq-table-column :label="`${prefix}排序`" prop="index"/>
        <yq-table-column label="图片" v-if="dictionSetting.imageType === 1" :align="'center'">
          <template v-slot="{row}">
            <image-show v-model="row.imageBackground" width="0.8rem" height="0.8rem" :limit="1"/>
          </template>
        </yq-table-column>
        <yq-table-column label="操作" align="center" width="120rem" fixed="right">
          <template v-slot="{row}">
            <table-button :disabled="!editAble" hasPerm="sys:dict:save" @click="toEditData(row)">编辑</table-button>
            <table-button :disabled="!editAble" hasPerm="sys:dict:remove" el-type="danger" message="是否确认删除此数据?" @click="toDelete(row)">删除</table-button>
          </template>
        </yq-table-column>
      </yq-table>
    </table-list>
    <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList" :default-load="false"/>
  </list-page>
  <el-dialog :title="`编辑${prefix}`" dialog-width="1" v-model="showDialog">
    <el-form label-width="2.4rem">
      <el-form-item :label="`${prefix}名称`">
        <el-input v-model="currentData.dictName" placeholder="请输入名称，用于识别"/>
      </el-form-item>
      <el-form-item :label="`${prefix}编码`">
        <el-input v-model="currentData.userCode" placeholder="请输入编码，编码不能重复"/>
      </el-form-item>
      <el-form-item :label="`${prefix}排序`">
        <el-input v-model="currentData.index" placeholder="请输入排序序号"/>
      </el-form-item>
      <el-form-item label="图片"  v-if="dictionSetting.imageType === 1">
        <image-upload v-model="currentData.imageBackground" :limit="1" :upload-tips="`图片尺寸: ${dictionSetting.imageSize}`" folder="dictionary"/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <page-button @click="showDialog = false">取消</page-button>
      <page-button el-type="primary" @click="saveData" type="write">保存</page-button>
    </div>
  </el-dialog>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import SearchCondition from "@/components/h5/layout/SearchCondition";
import TableList from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import TableButton from "@/components/h5/button/TableButton";
import PageButton from "@/components/h5/button/PageButton";
import ImageUpload from "@/components/h5/image/ImageUpload";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import util from "@/util/util";
export default {
  props: {
    dictionSetting: {
      default: () => {
        return {
          dictCode: "",
          dictName: "",
          imageType: 0,
          imageBackground: "",
          imageInfront: "",
          // 0:不可编辑，1:可编辑
          editAble: 0,
        }
      }
    },
    prefix: {default: "字典"}
  },
  name: "",
  components: {
    PageButton,
    TableButton,
    ListPage, SearchCondition, TableList, FormPage, ImageUpload, ImageShow
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showDialog: false,
      currentData: {},
      inStockDic: [],
      outStockDic: [],
      editAble: true,
      userInfo: {},
    };
  },
  created() {
    this.searchInfo.type = this.dictionSetting.dictCode;
    util.getUserInfo().then(user => {
      this.userInfo = user;
      if (this.dictionSetting.editAble === 0) {
        // 不可编辑，此时查询平台配置的信息
        this.editAble = user.merchantType === 1;
      }
      this.resetSearch();
    })
  },
  methods: {
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      if (this.dictionSetting.uniqueType === 1) { // 唯一字典
        dictionaryApi.queryUniqueList(this.searchInfo).then(res => {
          this.dataList = res.records;
          this.searchInfo.totalCount = res.totalCount;
        })
      } else {
        if (this.dictionSetting.editAble === 0) {// 不可编辑字典
          dictionaryApi.queryParentList(this.searchInfo).then(res => {
            this.dataList = res.records;
            this.searchInfo.totalCount = res.totalCount;
          })
        } else {
          dictionaryApi.queryList(this.searchInfo).then(res => {
            this.dataList = res.records;
            this.searchInfo.totalCount = res.totalCount;
          })
        }

      }
    },
    toEditData(data) {
      this.currentData = {...data};
      this.showDialog = true;
    },
    saveData() {
      if (this.dictionSetting.uniqueType === 1) { // 唯一字典
        dictionaryApi.saveUnique({
          ...this.currentData,
          type: this.dictionSetting.dictCode
        }).then(() => {
          this.queryList();
          this.showDialog = false;
        });
      } else {
        dictionaryApi.save({
          ...this.currentData,
          type: this.dictionSetting.dictCode
        }).then(() => {
          this.queryList();
          this.showDialog = false;
        });
      }

    },
    toDelete(data) {
      if (this.dictionSetting.uniqueType === 1) { // 唯一字典
        dictionaryApi.deleteUnique(this.dictionSetting.dictCode, data.id).then(() => this.queryList());
      } else {
        dictionaryApi.deleteById({id:data.id}).then(() => this.queryList());
      }

    }
  }
};
</script>

<style lang="scss" scoped>

</style>